const Footer = () => {
  return (
    <footer className="bg-black text-white py-8 w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo/Company Name */}
          <a href="/" aria-label="House Beat home">
            <img 
              src="/housebeat_logo.svg" 
              alt="House Beat Logo"
              className="h-8 w-auto brightness-0 invert"
            />
          </a>
          
          {/* Copyright */}
          <p className="text-gray-400 text-sm">
            © 2025 House Beat. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
